import { Injectable } from "@angular/core";
import { GeofenceHandlerService } from "../handlers/geofence-handler.service";
import { GeofenceDTO } from "./Geofence";

@Injectable({
  providedIn: "root",
})
export class GeofenceService {
  constructor(private GeofenceHandlerService: GeofenceHandlerService) {}

  //LIST
  getGeofences(
    masterAccountID: number,
    queryParams?: { facility_id?: number[]; page?: number; perPage?: number },
  ) {
    return this.GeofenceHandlerService.getGeofences(
      masterAccountID,
      queryParams,
    );
  }

  getGeofence(masterAccountID: number, geofenceID: number) {
    return this.GeofenceHandlerService.getGeofence(masterAccountID, geofenceID);
  }

  deleteGeofence(accountMasterID: number, geofenceID: number) {
    return this.GeofenceHandlerService.deleteGeofence(
      accountMasterID,
      geofenceID,
    );
  }

  createGeofence(accountMasterID: number, geofenceDTO: GeofenceDTO) {
    return this.GeofenceHandlerService.postGeofence(
      accountMasterID,
      geofenceDTO,
    );
  }

  updateGeofence(accountMasterID: number, geofenceDTO: GeofenceDTO) {
    return this.GeofenceHandlerService.putGeofence(
      accountMasterID,
      geofenceDTO,
    );
  }

  getIntersectingGeofences(masterAccountID: number, geofenceID: number) {
    return this.GeofenceHandlerService.getIntersectingGeofences(
      masterAccountID,
      geofenceID,
    );
  }
}
